import request from '../../axios';

export const postInternetInstallmentPay = async (loanGuid?: string) => {
  return await request.post(
    `/api/v2/payment/payment-installment/taken-loan/` + loanGuid,
  );
};
